<template>
    <router-view />
</template>

<script>
export default {
    name: 'RouterViewWrapper',
};
</script>
